module.exports = __webpack_public_path__ + "img/mail-icon.51f5d6778e8df963871ff985ff194985.svg";